/**
 * 모델
 * @window w_tb_sms_report
 * @category 문자송수신내역
 */
import { computed } from 'mobx';

export class TextTransmitModel {
  /**
   * 그룹코드
   *
   * **data type** varchar(50)
   */
  groupcd: string;

  /**
   * 전화구분
   * **data type** varchar(10)
   */
  telcd: string;

  callee: string;

  caller: string;

  custcd: string;

  dbid: string;

  mode: string;

  /**
   * 문자내용
   * **data type** varchar(10)
   */
  msg: string;

  recedate: string;

  recenum: string;

  recetime: string;

  result: string;

  type: string;

  callback: string;

  gubun: string;

  senddate: string;

  sendtime: string;

  subject: string;

  /*
  *  여부
  * */
  succ_count: string;

  fromnm: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.groupcd = data.groupcd || '';
    this.telcd = data.telcd || '';
    this.callee = data.callee || '';
    this.caller = data.caller || '';
    this.custcd = data.custcd || '';
    this.dbid = data.dbid || '';
    this.mode = data.mode || '';
    this.msg = data.msg || '';
    this.recedate = data.recedate || '';
    this.recenum = data.recenum || '';
    this.recetime = data.recetime || '';
    this.result = data.result || '';
    this.type = data.type || '';
    this.callback = data.callback || '';
    this.custcd = data.custcd || '';
    this.gubun = data.gubun || '';
    this.msg = data.msg || '';
    this.recenum = data.recenum || '';
    this.senddate = data.senddate || '';
    this.sendtime = data.sendtime || '';
    this.subject = data.subject || '';
    this.succ_count = data.succ_count || '';
    this.fromnm = data.fromnm || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
